import { DEV_URL, rpost } from "utils/requests";

export interface TransferLicensePayload {
  licenseId: string;
  targetCompanyId: string;
  reason: string;
}

export const transferLicense = async (payload: TransferLicensePayload): Promise<any> => {
  return await rpost(`${DEV_URL}/api/license/transfer`, payload);
};
